import styled from 'styled-components';
import { layout, getScrollBarStyles } from '../../../config/styles';
import { HEADER_Z_INDEX } from '../../../styles/zIndexes';
import { theme } from '../../../styles/theme';

export const ContainerRight = styled.div`
  position: fixed;
  right: 0;
  top: ${layout.headerHeight}px;
  width: ${layout.collaborationWidth}px;
  display: inline-block;
  height: calc(100vh - ${layout.headerHeight}px);
  background-color: #f2f5fc;
`;

export const WorkspaceHeader = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  z-index: ${HEADER_Z_INDEX};
  width: 100%;
  padding-top: 16px;
  padding-right: 24px;
  padding-left: 24px;
  background-color: ${theme.colors.level0};
`;

export const WorkspaceChartWrapper = styled.div`
  padding-right: 24px;
  padding-left: 24px;
`;

export const WorkspaceSaveTip = styled.div`
  flex: 0 0 auto;
  margin-left: 8px;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  color: ${theme.colors.secondary800};
`;

export const WorkspaceOptionMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  flex: 0 0 auto;
  margin-left: auto;
  column-gap: 8px;
`;

export const LeftContainer = styled.div`
  overflow-y: auto;
  width: calc(100% - ${layout.collaborationWidth}px);
  height: calc(100vh - ${layout.channelHeaderHeight}px);
  ${getScrollBarStyles(6)}
  border-right: 1px solid ${theme.colors.border};
`;
